"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

function Span(_a) {
  var _b;

  var children = _a.children,
      _c = _a.size,
      size = _c === void 0 ? "base" : _c,
      _d = _a.appearance,
      appearance = _d === void 0 ? "default" : _d,
      _e = _a.background,
      background = _e === void 0 ? false : _e,
      _f = _a.bold,
      bold = _f === void 0 ? false : _f;
  var className = classnames_1.default("nimbus--text", "nimbus--text-span", "nimbus--text-size--" + size, "nimbus--text-color--" + appearance, (_b = {}, _b["nimbus--text-background--" + appearance] = background, _b), {
    "nimbus--text--bold": bold
  });
  return React.createElement("span", {
    className: className
  }, children);
}

exports.default = Span;